<template>
  <div class="bg-container">
    <div class="login">
      <van-nav-bar>
        <template #left>
          <van-icon name="arrow-left" color="#8a63c9" @click="back()"/>
        </template>
      </van-nav-bar>
      <div class="logo">
        <img src="/img/login/logo2.png" alt="">
      </div>
      <div class="panel">
        <div class="wrap">
          <div class="input_wrap">
            <van-icon name="contact-o" size="16" color="#b79cec"></van-icon>
            <input type="text" :placeholder="$t('auth.username_place')" v-model="username">
          </div>
          <div class="input_wrap">
            <img src="/img/login/password.png" alt="" style="width: 1.00rem; height: 1.00rem;">
            <input :placeholder="$t('auth.pwd_place')" v-model="password" :type="pwdType == 1 ? 'password' : 'text'">
            <van-icon :name="pwdType == 0 ? 'eye-o' : 'closed-eye'" color="#b79cec" size="24" @click="pwdType = pwdType == 1 ? 0 : 1"></van-icon>
          </div>
          <div class="input_wrap">
            <img src="/img/login/code.png" alt="" style="width: 1.00rem; height: 1.00rem;">
            <input type="text" :placeholder="$t('auth.invite_code_place')" v-model="code">
          </div>
        </div>
        <div class="button" @click="doRegister()">{{$t("auth.register")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pwdType: 1,
      checked: true,
      username: '',
      code: '',
      lang: 'en_us',
      password: this.inputValue,
      passwordType: 'password',
    };
  },
  mounted(){
    
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    doRegister() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.$http({
        method: 'post',
        data:{
          username:this.username,
          password:this.password,
          code:this.code
        },
        url: 'member_register'
      }).then(res=>{
          if(res.code === 200){
            this.$toast.success(res.msg);
            localStorage.setItem('token',res.data)
            this.$router.push("Mine")
          }else {
            this.$toast.fail(res.msg);
          }
      })
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import '~@/assets/css/theme.less';

.van-nav-bar {
  background: none;
  .van-icon {
    font-size: 1.38rem;
  }
}
.bg-container {
  background-image: @bg-soft;
  height: 100%;
}
.login {
  height: 100%;
  width: 100%;
  background:
    linear-gradient(180deg, rgba(255, 244, 248, 0) 20%, rgba(250, 238, 255, 0.5) 62%, rgba(255, 240, 232, 0.92) 100%),
    url('/public/img/login/bg2.png') no-repeat 50% / 100%;
  overflow: hidden;
}

.logo {
  width: 13.50rem;
  margin: 4.6rem auto 1.1rem;
  img{
    width: 100%;
    filter: drop-shadow(0 0.4rem 1.2rem rgba(255, 255, 255, 0.55));
  }
}

.panel {
  width: 88%;
  margin: 0 auto;
  padding: 1.6rem 0.4rem 1.9rem;
  border-radius: 1.6rem;
  background: rgba(255, 255, 255, 0.62);
  border: @glass-border;
  box-shadow: 0 1rem 2.4rem rgba(160, 110, 190, 0.22);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.wrap{
  .input_wrap{
    width: 90%;
    height: 3.3rem;
    margin: 0.9rem auto;
    border-radius: @radius-pill;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid rgba(183, 156, 236, 0.35);
    box-shadow: 0 0.2rem 0.7rem rgba(183, 156, 236, 0.14);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 1.33333rem;
    input{
      flex: 1;
      height: 100%;
      border: none;
      background: none;
      outline: none;
      text-align: left;
      font-size: .93333rem;
      padding-left: 1rem;
      color: @text-title;
      &::placeholder {
        color: @text-sub;
      }
    }
  }
}

.row {
  font-size: 0.95rem;
  color: #8a63c9;
  font-weight: 500;
  margin: 1.1rem auto 0;
  text-align: center;
}

.button{
  width: 90%;
  background: @grad-primary;
  box-shadow: @shadow-pink;
  font-size: 1.13rem;
  font-weight: 600;
  letter-spacing: 0.08rem;
  color: #fff;
  text-align: center;
  height: 3.13rem;
  line-height: 3.13rem;
  border-radius: @radius-pill;
  margin: 1.3rem auto 0;
}
</style>
